export const COPY_PROJECT_FLOW = {
  ADD_PROJECT: 'ADD_PROJECT',
  EDIT_PROJECT: 'EDIT_PROJECT'
};
